module.exports = __webpack_public_path__ + "media/images/lane/street-background-aa5feb5f1c17136b52ab65c817978277.svg";